import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiX, FiMenu } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../utils/funcs";
import LanguageSwitcher from "./LanguageSwitcher";

interface HeaderProps {
  color?: string;
  stickyNav?: boolean;
}

const Header = ({ color = "default-color", stickyNav = true }: HeaderProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    const headerElement = document.querySelector(".header--fixed");

    const stickHeader = () => {
      const value = window.scrollY;
      if (value > 50 && stickyNav) {
        headerElement?.classList.add("sticky");
      } else {
        headerElement?.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", stickHeader);

    return () => {
      window.removeEventListener("scroll", stickHeader);
    };
  }, [stickyNav]);

  useEffect(() => {
    const elements = document.querySelectorAll(".has-droupdown > a");
    Object.entries(elements).forEach(([, value]) => {
      (value as HTMLElement).onclick = function () {
        value.parentElement
          ?.querySelector(".submenu")
          ?.classList.toggle("active");
        value.classList.toggle("open");
      };
    });
  }, []);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper")?.classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper")?.classList.remove("menu-open");
  };

  const handleChange = () => {
    scrollToTop();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      scrollToTop();
    }
  };

  const handleMenuKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      menuTrigger();
    }
  };

  const handleCloseKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      closeMenuTrigger();
    }
  };

  return (
    <header
      className={`header-area header--fixed formobile-menu header--transparent ${color}`}
    >
      <div className="header-wrapper" id="header-wrapper">
        <div className="header-left">
          <div className="header-btn">
            <Link
              className="btn-default btn-border btn-opacity size-lg"
              to="/cases"
              onClick={handleChange}
              onKeyDown={handleKeyDown}
            >
              <span>CEM</span>
            </Link>
          </div>
        </div>
        <div className="header-right">
          <nav className="mainmenunav d-lg-block">
            <ul className="mainmenu">
              <li>
                <Link to="/">{t("nav.home")}</Link>
              </li>

              <li className="has-droupdown">
                <Link
                  to="/about"
                  onClick={handleChange}
                  onKeyDown={handleKeyDown}
                >
                  {t("nav.about")}
                </Link>
                <ul className="submenu">
                  <li>
                    <Link
                      to="/about/contributors"
                      onClick={handleChange}
                      onKeyDown={handleKeyDown}
                    >
                      {t("nav.contributors", "Contributors")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link
                  to="/cases"
                  onClick={handleChange}
                  onKeyDown={handleKeyDown}
                >
                  {t("nav.cases")}
                </Link>
              </li>
              <li>
                <Link
                  to="/archive"
                  onClick={handleChange}
                  onKeyDown={handleKeyDown}
                >
                  {t("nav.archive")}
                </Link>
              </li>
              {/* Evidence page is live at /evidence but intentionally not
                  in the menu yet — reachable by direct link only. */}
              <li>
                <Link
                  to="/contact"
                  onClick={handleChange}
                  onKeyDown={handleKeyDown}
                >
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </nav>

          <div className="language-switcher-wrapper d-none d-lg-block pl--20">
            <LanguageSwitcher />
          </div>

          {/* Start Hamburger Menu  */}
          <div className="humberger-menu d-block d-lg-none pl--20 pl_sm--10">
            <span
              onClick={menuTrigger}
              onKeyDown={handleMenuKeyDown}
              className="menutrigger text-white"
              role="button"
              tabIndex={0}
              aria-label="Hamburger menu"
            >
              <FiMenu />
            </span>
          </div>
          {/* End Hamburger Menu  */}
          <div className="close-menu d-block d-lg-none">
            <span
              onClick={closeMenuTrigger}
              onKeyDown={handleCloseKeyDown}
              className="closeTrigger"
              role="button"
              tabIndex={0}
              aria-label="Closes menu trigger"
            >
              <FiX />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
